import type { Document } from '@/types/document';

export const mockDocuments: Document[] = [
    {
        id: '1',
        name: 'product-manual.pdf',
        type: 'PDF',
        size: 2457600,
        uploadDate: new Date(2025, 4, 15),
        status: 'processed'
    },
    {
        id: '2',
        name: 'faq-database.csv',
        type: 'CSV',
        size: 857000,
        uploadDate: new Date(2025, 4, 10),
        status: 'processed'
    },
    {
        id: '3',
        name: 'api-documentation.md',
        type: 'Markdown',
        size: 345000,
        uploadDate: new Date(2025, 4, 17),
        status: 'pending'
    },
    {
        id: '4',
        name: 'technical-specifications.docx',
        type: 'DOCX',
        size: 1245000,
        uploadDate: new Date(2025, 4, 12),
        status: 'error'
    }
]; 